// import { getEnvs } from '@/shared/utils';
// const { VITE_BUCKET_BASE } = getEnvs();
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  emptyCellOneLevel,
  formatDateWithTime,
  hasAllPermissions,
  useCheckPermissions,
  useTableServerSideFiltering,
} from "@/shared";
import { useDeleteOperadora, useFetchOperadoras } from "@/shared/actions/erp";
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useTableFilter } from "@/shared/hooks/useTableFilter";
import { useUiConfirmModalStore } from "@/store/ui";
import { SAVE_OPERADORA_PERMISSIONS } from "../../shared/constants";
import { Operadora } from '@/shared/interfaces/erp/configuracion-red/operadora';

export type OperadoraPageProps = {};

const OperadoraPage: React.FC<OperadoraPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_operadora);

  const returnUrlOperadoraPage = ROUTER_PATHS.configuracionRED.operadoraNav;

  const navigate = useNavigate();

  ///* global state
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  const deleteOperadora = useDeleteOperadora();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  const { filterObject, columnFilters, setColumnFilters } =
      useTableServerSideFiltering();

  ///* fetch data
  const {
    data: OperadoraPagingRes,
    isLoading,
    isRefetching,
  } = useFetchOperadoras({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      codigo: searchTerm,
      ...filterObject,
    },
  });

  ///* handlers

  const onEdit = (operadora: Operadora) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar Operadora",
      subtitle: "¿Está seguro que desea editar este Operadora?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrlOperadoraPage}/editar/${operadora.id_operadora}`);
      },
    });
  };

  const onDelete = (operadora: Operadora) => {
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar Operadora",
      subtitle: "¿Está seguro que desea eliminar este Operadora?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteOperadora.mutate(operadora.id_operadora!);
      },
    });
  };

  const columns = useMemo<MRT_ColumnDef<Operadora>[]>(
    () => [
      {
        accessorKey: "codigo",
        header: "Código",
        size: 180,
      },
      {
        accessorKey: "nombre",
        header: "Nombre",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "nombre"),
      },
      {
        accessorKey: "fecha_creacion",
        header: "Fecha de Creación",
        size: 180,
        Cell: ({ row }) =>
          formatDateWithTime(row.original?.fecha_creacion || ""),
      },
      {
        accessorKey: "fecha_modificacion",
        header: "Fecha de Modificación",
        size: 180,
        Cell: ({ row }) =>
          formatDateWithTime(row.original?.fecha_modificacion || ""),
      },
    ],
    []
  );

  //CUSTOM HOOKS

  // const { fileInputRef: importOperadora, handleImportarOLT } = useUploadFile();

  return (
    <SingleTableBoxScene
      title="Operadora"
      urlRedirect={`${returnUrlOperadoraPage}/crear`}
      enableRedirect={hasAllPermissions([
        ...SAVE_OPERADORA_PERMISSIONS,
        PermissionsEnum.api_add_operadora,
      ])}
      //excel
      // enableUploadFile={true}
      // enableDownloadFile={true}
      // fileInputRef={importOperadora}
      // importationName={"Subir Operadora"}
      // handleFileUpload={handleImportarOLT}
      // importationsQuantity={1}
      // urlDownloadPlantilla={
      //   "/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_OLT
      // }
      // urlDownloadNameExcel={"plantilla_olt"}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="por código de Operadora"
        cleanFilter={cleanFilter}
      />

      <GeneralTable<Operadora>
        columns={columns}
        data={OperadoraPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={OperadoraPagingRes?.data?.count}
        ///* filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // actions ========
        enableColumnActions={hasAllPermissions([
          ...SAVE_OPERADORA_PERMISSIONS,
          PermissionsEnum.api_change_operadora,
        ])}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={hasAllPermissions([
          ...SAVE_OPERADORA_PERMISSIONS,
          PermissionsEnum.api_change_operadora,
        ])}
        onEdit={onEdit}
        canDelete={false}
        onDelete={onDelete}
      />
    </SingleTableBoxScene>
  );
};

export default OperadoraPage;
